import React from 'react'
import { debounce } from 'throttle-debounce'

function useDebounce(callback, delay) {
  const callbackRef = React.useRef(callback)

  // Why useLayoutEffect? -> https://kcd.im/uselayouteffect
  React.useLayoutEffect(() => {
    callbackRef.current = callback
  })

  return React.useMemo(() => debounce(delay, callbackRef.current), [delay])
}

export default useDebounce
